import { prop, compose, applySpec, defaultTo } from 'ramda';

export default applySpec({
	id: prop('ID'),
	index: prop('INDEX'),
	work: prop('WORK'),
	iris: prop('IRIS'),
	amount: prop('amount'),
	price: prop('PRICE'),
	priceBrand: prop('PRICE_BRAND'),
	parts: compose(
		defaultTo({}),
		prop('SPARES')
	),
	isEditable: prop('CAN_EDIT'),
});
